"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = void 0;
var container_1 = require("../dic/container");
var config_1 = require("../dic/config");
var i18nFactory = container_1.default.get(config_1.default.I18N_FACTORY);
exports.i18n = i18nFactory.create();
